import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import AuthNavComponent from "app/pages/module/auth/AuthNav";
import Footer from "app/pages/module/Footer";
import { Pagination } from "app/pages/component/Pagination";
import { TransactionsTable } from "app/pages/component/TransactionsTable";
import CommonFormHeader from "sr/layout/common/CommonFormHeader";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import { getStripeTransactions } from "sr/utils/api/strip/getStripeTransactions";

export const CleanerMyTransactions = () => {
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState<any>(null);
  const [page, setPage] = useState(1);
  const limit = 10;

  useEffect(() => {
    const fetchTransactions = async () => {
      setLoading(true);
      const queryParams = new URLSearchParams();
      queryParams.append("limit", String(limit));
      queryParams.append("page", String(page));
      const res = await getStripeTransactions(queryParams.toString());
      setRows(Array.isArray(res?.data) ? res.data : []);
      setPagination(res?.pagination || null);
      setLoading(false);
    };
    fetchTransactions();
  }, [limit, page]);

  const total = Number(pagination?.total || 0);
  const pageSize = Number(pagination?.pageSize || limit);
  const totalPage =
    total && pageSize ? Math.max(1, Math.ceil(total / pageSize)) : 1;

  return (
    <>
      <AuthNavComponent isLoggedin={true} />
      <main className="lg:container mx-auto lg:max-w-6xl lg:mt-10 mt-10 px-4 lg:px-0 pb-10">
        <CommonFormHeader
          title={
            <>
              <FormattedMessage
                id="CLEANER.TRANSACTIONS.TITLE"
                defaultMessage="My Transactions"
              />
              <span className="text-neutral-500"> ({total})</span>
            </>
          }
        />

        <ContentWithSpinner loader={loading} height="h-screen">
          <div className="rounded-[18px] border border-gray-border bg-white p-5">
            {rows.length ? (
              <TransactionsTable
                rows={rows}
                mode="receiver"
                workorderLinkBase="/cleaner/work-order-details"
                titleLabel="Work Order"
                titleColumnClassName="w-[320px]"
                tableLayout="auto"
              />
            ) : (
              <div className="text-sm text-neutral-500">
                No transactions found.
              </div>
            )}

            {totalPage > 1 ? (
              <Pagination page={page} totalPage={totalPage} setPage={setPage} />
            ) : null}
          </div>
        </ContentWithSpinner>
      </main>
      <Footer />
    </>
  );
};
